/* istanbul ignore file */

import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { spacing } = theme;

const ACTIVE_THUMBNAIL_BORDER_PX = 1;
const ACTIVE_THUMBNAIL_SPACING_PX = spacing.base;

const activeThumbnailBorderAndSpacingPx = ACTIVE_THUMBNAIL_SPACING_PX + ACTIVE_THUMBNAIL_BORDER_PX;

export const root = css`
  margin: 0;
  overflow-x: auto;
  overflow-y: hidden;
`;

export const thumbnailsWithKeyboardFocus = css`
  border-radius: 14px;
  box-shadow: 0 0 0 3px var(--neutral-white-base), 0 0 0 5px var(--brand-purple-base);
`;

export const list = css`
  display: flex;
  list-style-type: none;
  margin: 0;

  padding: ${activeThumbnailBorderAndSpacingPx}px;
`;

export const listItem = css`
  flex-shrink: 0;
  flex-basis: 90px;
  margin: 0 ${spacing.sm}px 0 0;

  &:last-child {
    padding-right: ${activeThumbnailBorderAndSpacingPx}px;
  }
`;

export const image = css`
  border-radius: 10px;
`;

export const imageLink = css`
  display: block;
  opacity: 0.4;
  position: relative;
  line-height: 0;
  height: 0;
  padding-bottom: 100%;

  .js-focus-visible &.focus-visible {
    box-shadow: 0 0 0 ${ACTIVE_THUMBNAIL_SPACING_PX}px var(--neutral-white-base),
      0 0 0 ${activeThumbnailBorderAndSpacingPx}px var(--brand-purple-base);
  }

  &[aria-selected='true'] {
    opacity: 1;
    box-shadow: 0 0 0 ${ACTIVE_THUMBNAIL_SPACING_PX}px var(--neutral-white-base),
      0 0 0 ${activeThumbnailBorderAndSpacingPx}px var(--brand-purple-base);
    border-radius: 10px;
  }
`;
